import styled, { css } from 'styled-components';
import convertHexToRgba from '~/helpers/convertHexToRgba';

const WifiSecurityStyled = styled.div.attrs({
  className: 'wifi-secure-offer-screen',
})`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      align-items: center;
      background-color: ${colors.primary.white};
      box-shadow: 0 20px 40px 0 ${convertHexToRgba(colors.primary.black, 0.25)};
      display: flex;
      flex-direction: column;
      min-width: 343px;
      width: 343px;
      padding: 32px 16px;
      border-radius: 32px;
      position: relative;
      font-weight: 700;
      text-align: center;

      ${media.desktop.up} {
        min-width: 1000px;
      }

      ${media.tablet.only} {
        padding: 64px;
        min-width: 600px;
      }

      .wifi-secure-offer-screen {
        width: 100%;
        &__close-button {
          position: absolute;
          top: 0;
          right: 0;
          cursor: pointer;
          height: 45px;
          width: 45px;
          padding: 16px;

          ${media.tablet.up} {
            height: 60px;
            width: 60px;
            padding: 20px;
          }
        }

        &__heading {
          color: ${colors.primary.gravity};
          font-size: 20px;
          font-weight: 700;
          line-height: 24px;
          text-align: center;
          margin-bottom: 16px;

          ${media.tablet.up} {
            font-size: 30px;
            line-height: 34px;
            margin-bottom: 32px;
          }
        }

        &__subheading {
          color: ${colors.primary.gravity};
          font-weight: 400;

          ${media.tablet.up} {
            font-size: 18px;
            line-height: 26px;
            max-width: 875px;
          }
        }

        &__btn {
          text-transform: uppercase;
          width: 226px;
          margin-bottom: 16px;
          margin-top: 16px;
          ${media.tablet.up} {
            margin-top: 32px;
            margin-bottom: 32px;
          }
        }

        &__decline {
          border: none;
          background: none;
          color: ${colors.primary.gravity};
          cursor: pointer;
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
          text-decoration: underline;
        }

        &__fine-print {
          color: ${colors.primary.gravity};
          font-size: 11px;
          font-weight: 400;
          line-height: 11px;
          ${media.tablet.up} {
            margin-top: 32px;
          }
          strong {
            text-decoration: underline;
          }
        }
      }
    `;
  }}
`;

export default WifiSecurityStyled;
